import { render } from "./TopDetail.vue?vue&type=template&id=d4073ef4"
import script from "./TopDetail.vue?vue&type=script&lang=js"
export * from "./TopDetail.vue?vue&type=script&lang=js"

import exportComponent from "/builds/benoit67/django-business-center-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__